import { createReducer, on } from '@ngrx/store';
import { lifeCycleActions } from '../life-cycle/life-cycle.actions';
import { examinationResponseToStoreExamination } from './adapters/store-examination.adapter';
import { examinationsActions } from './examinations.actions';
import { initialExaminationState } from './examinations.state';
import { StoreExaminationsById } from './models/store-examinations-by-id';

export const examinationsReducer = createReducer(
  initialExaminationState,

  on(lifeCycleActions.resetState, () => initialExaminationState),

  on(examinationsActions.updateExaminationsState, (state, { clientCode, patientId, examinations, departmentId }) => {
    const examinationList = Object.values(examinations).flat();

    return {
      ...state,
      [clientCode]: {
        ...state[clientCode],
        [patientId]: {
          ...state[clientCode]?.[patientId],
          examinations: {
            ...state[clientCode]?.[patientId]?.examinations,
            ...(Object.fromEntries(
              examinationList.map((examination) => [
                examination.id,
                examinationResponseToStoreExamination(examination),
              ]),
            ) as StoreExaminationsById),
          },
          departments: {
            ...state[clientCode]?.[patientId]?.departments,
            ...(departmentId ? { [departmentId]: examinationList.map((e) => e.id) } : {}),
          },
        },
      },
    };
  }),

  on(examinationsActions.addExamination, (state, { clientCode, examinationResponse, departmentId }) => {
    const patientId = examinationResponse.patientId;
    const storeExamination = examinationResponseToStoreExamination(examinationResponse);

    const departmentExaminations = new Set([
      ...(state[clientCode]?.[patientId]?.departments?.[departmentId] || []),
      storeExamination.id,
    ]);

    return {
      ...state,
      [clientCode]: {
        ...state[clientCode],
        [patientId]: {
          ...state[clientCode]?.[patientId],
          examinations: {
            ...state[clientCode]?.[patientId]?.examinations,
            [storeExamination.id]: storeExamination,
          },
          departments: {
            ...state[clientCode]?.[patientId]?.departments,
            ...(departmentId
              ? {
                  [departmentId]: Array.from(departmentExaminations),
                }
              : {}),
          },
        },
      },
    };
  }),

  on(examinationsActions.deleteExamination, (state, { clientCode, patientId, departmentId, examinationId }) => {
    const patientExaminationState = state[clientCode]?.[patientId];
    if (!patientExaminationState) {
      return state;
    }

    const { [examinationId]: removedExamination, ...remainingExaminations } = patientExaminationState.examinations;

    const updatedDepartments = { ...patientExaminationState.departments };
    if (departmentId && updatedDepartments[departmentId]) {
      updatedDepartments[departmentId] = updatedDepartments[departmentId].filter((id) => id !== examinationId);
      if (updatedDepartments[departmentId].length === 0) {
        delete updatedDepartments[departmentId];
      }
    }

    return {
      ...state,
      [clientCode]: {
        ...state[clientCode],
        [patientId]: {
          ...patientExaminationState,
          examinations: remainingExaminations,
          departments: updatedDepartments,
        },
      },
    };
  }),
);
